import React, { useState, useCallback, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";

import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";

import Paper from "Components/UI/Paper";
import { useEndCustomerPaymentBundles } from "Context/EndCustomerPaymentBundles";
import { usePopupNotificationContext } from "Context/NotificationPopup";
import { EndCustomerPaymentBundleForm } from "Components/EndCustomerPaymentBundle/EndCustomerPaymentBundleForm";

export function EndCustomerPaymentBundleCard() {
  const { getPaymentBundleById, updatePaymentBundle } =
    useEndCustomerPaymentBundles();
  const { paymentBundleID } = useParams();
  const { openSuccess, openError } = usePopupNotificationContext();
  const [editMode, setEditMode] = useState(false);
  const [formData, setFormData] = useState(null);
  const navigate = useNavigate();

  const asyncUpdatePaymentBundle = async (body) => {
    const res = await updatePaymentBundle(body.Id, body);
    if (res) {
      setFormData({ ...res });
      openSuccess("OK", 3000);
      setEditMode(false);
    } else {
      openError("Något gick fel", 3000);
    }
  };

  useEffect(() => {
    const asyncGetPaymentBundle = async (id) => {
      const paymentBundle = await getPaymentBundleById(id);
      if (paymentBundle) {
        setFormData({ ...paymentBundle });
      }
    };

    asyncGetPaymentBundle(paymentBundleID);
  }, [paymentBundleID]);

  const handleInputChange = useCallback(
    (field, newVal) => {
      setFormData({ ...formData, [field]: newVal });
    },
    [formData]
  );

  if (!formData) {
    return null;
  }

  return (
    <>
      <Paper>
        <Box sx={{ display: "flex", justifyContent: "space-between" }}>
          <Typography sx={{ marginBottom: "1.0rem" }} variant="h5" align="left">
            Inbetalningsbunt - {formData.Id}
          </Typography>
        </Box>
        <EndCustomerPaymentBundleForm
          formData={formData}
          FORM_MODE={editMode ? "EDIT" : "LOCKED"}
          handleInputChange={handleInputChange}
        />

        <Grid
          item
          xs={12}
          sx={{ marginTop: 2, display: "flex", justifyContent: "flex-end" }}
        >
          {editMode ? (
            <>
              <Button
                size="small"
                onClick={() => setEditMode(false)}
                sx={{ ml: 1, display: editMode ? "block" : "none" }}
              >
                Stäng
              </Button>
              <Button
                size="small"
                onClick={() => asyncUpdatePaymentBundle(formData)}
                sx={{ ml: 2 }}
                variant="contained"
              >
                Spara
              </Button>
            </>
          ) : (
            <>
              <Button size="small" onClick={() => navigate(-1)}>
                Stäng
              </Button>
              <Button
                size="small"
                onClick={() => setEditMode(true)}
                variant="contained"
                sx={{ ml: 2, display: editMode ? "none" : "block" }}
              >
                Editera
              </Button>
            </>
          )}
        </Grid>
      </Paper>
    </>
  );
}
